/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DietitianAppointmentAnonymousRequest } from '../model';
// @ts-ignore
import { DietitianAppointmentMemberRequest } from '../model';
// @ts-ignore
import { DietitianBriefResponse } from '../model';
/**
 * DietitianControllerApi - axios parameter creator
 * @export
 */
export const DietitianControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DietitianAppointmentAnonymousRequest} dietitianAppointmentAnonymousRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnonymousDietitianAppointment: async (dietitianAppointmentAnonymousRequest: DietitianAppointmentAnonymousRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dietitianAppointmentAnonymousRequest' is not null or undefined
            assertParamExists('createAnonymousDietitianAppointment', 'dietitianAppointmentAnonymousRequest', dietitianAppointmentAnonymousRequest)
            const localVarPath = `/dietitians/appointments/anonymous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dietitianAppointmentAnonymousRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DietitianAppointmentMemberRequest} dietitianAppointmentMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberDietitianAppointment: async (dietitianAppointmentMemberRequest: DietitianAppointmentMemberRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dietitianAppointmentMemberRequest' is not null or undefined
            assertParamExists('createMemberDietitianAppointment', 'dietitianAppointmentMemberRequest', dietitianAppointmentMemberRequest)
            const localVarPath = `/dietitians/appointments/member`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dietitianAppointmentMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDietaryGoals: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dietitians/dietary-goals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDietitiansByUser: async (partnerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listDietitiansByUser', 'partnerId', partnerId)
            const localVarPath = `/dietitians`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DietitianControllerApi - functional programming interface
 * @export
 */
export const DietitianControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DietitianControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DietitianAppointmentAnonymousRequest} dietitianAppointmentAnonymousRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnonymousDietitianAppointment(dietitianAppointmentAnonymousRequest: DietitianAppointmentAnonymousRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnonymousDietitianAppointment(dietitianAppointmentAnonymousRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DietitianAppointmentMemberRequest} dietitianAppointmentMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMemberDietitianAppointment(dietitianAppointmentMemberRequest: DietitianAppointmentMemberRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMemberDietitianAppointment(dietitianAppointmentMemberRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDietaryGoals(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDietaryGoals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDietitiansByUser(partnerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DietitianBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDietitiansByUser(partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DietitianControllerApi - factory interface
 * @export
 */
export const DietitianControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DietitianControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DietitianAppointmentAnonymousRequest} dietitianAppointmentAnonymousRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnonymousDietitianAppointment(dietitianAppointmentAnonymousRequest: DietitianAppointmentAnonymousRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createAnonymousDietitianAppointment(dietitianAppointmentAnonymousRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DietitianAppointmentMemberRequest} dietitianAppointmentMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberDietitianAppointment(dietitianAppointmentMemberRequest: DietitianAppointmentMemberRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createMemberDietitianAppointment(dietitianAppointmentMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDietaryGoals(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.listDietaryGoals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDietitiansByUser(partnerId: string, options?: any): AxiosPromise<Array<DietitianBriefResponse>> {
            return localVarFp.listDietitiansByUser(partnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DietitianControllerApi - object-oriented interface
 * @export
 * @class DietitianControllerApi
 * @extends {BaseAPI}
 */
export class DietitianControllerApi extends BaseAPI {
    /**
     * 
     * @param {DietitianAppointmentAnonymousRequest} dietitianAppointmentAnonymousRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DietitianControllerApi
     */
    public createAnonymousDietitianAppointment(dietitianAppointmentAnonymousRequest: DietitianAppointmentAnonymousRequest, options?: AxiosRequestConfig) {
        return DietitianControllerApiFp(this.configuration).createAnonymousDietitianAppointment(dietitianAppointmentAnonymousRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DietitianAppointmentMemberRequest} dietitianAppointmentMemberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DietitianControllerApi
     */
    public createMemberDietitianAppointment(dietitianAppointmentMemberRequest: DietitianAppointmentMemberRequest, options?: AxiosRequestConfig) {
        return DietitianControllerApiFp(this.configuration).createMemberDietitianAppointment(dietitianAppointmentMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DietitianControllerApi
     */
    public listDietaryGoals(options?: AxiosRequestConfig) {
        return DietitianControllerApiFp(this.configuration).listDietaryGoals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DietitianControllerApi
     */
    public listDietitiansByUser(partnerId: string, options?: AxiosRequestConfig) {
        return DietitianControllerApiFp(this.configuration).listDietitiansByUser(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
}

